import React from 'react';
import MessageInbox from '../components/messaging/MessageInbox';
import { useAuth } from '../contexts/AuthContext';
import { Navigate } from 'react-router-dom';

const MessagingPage = () => {
  const { isAuthenticated, loading } = useAuth();

  // Redirect to login if not authenticated
  if (!loading && !isAuthenticated) {
    return <Navigate to="/signin" />;
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">Messages</h1>
        <p className="text-gray-600 mb-8">
          Connect with other biotech professionals and companies through our secure messaging system.
          Your email address is never shared with other users.
        </p>
        
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
          <MessageInbox />
        </div>
      </div>
    </div>
  );
};

export default MessagingPage; 